import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getCharAccount = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RegistroContable/getCharAccount', 'GET')
    return respuesta
};

export const getCuentasSecundarias = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RegistroContable/getCharAccountSecundarias', 'GET')
    return respuesta
};
export const getCharAccountConcat = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RegistroContable/getCharAccountConcat', 'GET')
    return respuesta
};

export const getCharAccountConcatProveedores = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RegistroContable/getCharAccountConcatProveedores', 'GET')
    return respuesta
};

export const getAccountType = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RegistroContable/getAccountType', 'GET')
    return respuesta
}

export const getCategories = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RegistroContable/getCategories', 'GET')
    return respuesta
}

export const getSubCategories = async () => {
    const respuesta = await PrivateInterceptor('Finanzas/RegistroContable/getSubCategories', 'GET');
    return respuesta;
}

export const getClases = async () => {
    const respuesta = await PrivateInterceptor('Finanzas/RegistroContable/getClases', 'GET');
    return respuesta;
}

export const getCuentasHijosQuick = async() =>{
    const result = await PrivateInterceptor(`Finanzas/RegistroContable/cuentasConcatenadas`, 'GET');
    return result;
}

export const getCuentasExistentes = async () => {
    const result = await PrivateInterceptor(`Finanzas/RegistroContable/cuentasHermanas`, 'GET');
    return result;
}

//------------------------------------ AGREGAR Y EDITAR --------------------------------------

export const GuardarAccounType = (DatosAccountType) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/GuardarAccounType", "POST", {DatosAccountType});
    return respuesta;
};

export const EditarAccounType = (DatosAccountType) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/EditarAccounType", "POST", {DatosAccountType});
    return respuesta;
};

export const GuardarCategories = (DatosCategories) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/GuardarCategories", "POST", {DatosCategories});
    return respuesta;
};

export const EditarCategories = (DatosCategories) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/EditarCategories", "POST", {DatosCategories});
    return respuesta;
};

export const GuardarSubCategories = (DatosSubCategories) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/GuardarSubCategories", "POST", {DatosSubCategories});
    return respuesta;
};

export const EditarSubCategories = (DatosSubCategories) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/EditarSubCategories", "POST", {DatosSubCategories});
    return respuesta;
};

export const GuardarCharAccount = (Datos) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/GuardarCharAccount", "POST", {Datos});
    return respuesta;
};

export const EditarCharAccount = (Datos) => {
    const respuesta = PrivateInterceptor("Finanzas/RegistroContable/EditarCharAccount", "POST", {Datos});
    return respuesta;
};

export const cambiarEstado = async (data) => {
    const result = await PrivateInterceptor(`Finanzas/RegistroContable/cambiarEstadoCuenta`, 'POST', data);
    return result;
}